<template>
  <v-container py-0>
    <og-table>
      <og-table-head>
        <tr>
          <th class="worker-name-cell">{{ $t('Documento / Nómina') }}</th>
          <th class="pa-0 text-xs-center" v-for="(month, i) in months" :key="i">
            {{ month.label }}
          </th>
        </tr>
      </og-table-head>

      <og-table-body v-if="documentsReady">
        <tr v-for="document in retencionesDocumentTypes" :key="document.value">
          <td>{{ $t(document.label) }}</td>
          <td class="pa-0 text-xs-center" v-for="month in months" :key="month.number">
            <template v-if="retencionesDocuments[document.value][year + '-' + month.number]">
              <v-btn
                v-if="retencionesDocuments[document.value][year + '-' + month.number].length === 1"
                @click="
                  downloadEntity(retencionesDocuments[document.value][year + '-' + month.number][0])
                "
                color="primary"
                icon
                flat
              >
                <v-icon>mdi-file-document-outline</v-icon>
              </v-btn>
              <v-btn
                v-if="retencionesDocuments[document.value][year + '-' + month.number].length > 1"
                @click="
                  multiDownload(retencionesDocuments[document.value][year + '-' + month.number])
                "
                color="primary"
                icon
                flat
              >
                <v-icon>mdi-package-variant-closed</v-icon>
              </v-btn>
            </template>
          </td>
        </tr>
        <tr v-for="type in tcDocumentTypes" :key="type.value">
          <td>{{ $t(type.label) }}</td>
          <td class="pa-0 text-xs-center" v-for="month in months" :key="month.number">
            <template v-if="tcDocuments[type.value][year + '-' + month.number]">
              <v-btn
                v-if="tcDocuments[type.value][year + '-' + month.number].length === 1"
                @click="downloadEntity(tcDocuments[type.value][year + '-' + month.number][0])"
                color="primary"
                icon
                flat
              >
                <v-icon>mdi-file-document-outline</v-icon>
              </v-btn>
              <v-btn
                v-if="tcDocuments[type.value][year + '-' + month.number].length > 1"
                @click="multiDownload(tcDocuments[type.value][year + '-' + month.number])"
                color="primary"
                icon
                flat
              >
                <v-icon>mdi-package-variant-closed</v-icon>
              </v-btn>
            </template>
          </td>
        </tr>
        <tr v-for="worker in documentWorkers" :key="worker.value">
          <td>{{ $t(worker.label) }}</td>
          <td class="pa-0 text-xs-center" v-for="month in months" :key="month.number">
            <template v-if="documents[worker.value][year + '-' + month.number]">
              <v-btn
                v-if="documents[worker.value][year + '-' + month.number].length === 1"
                @click="downloadEntity(documents[worker.value][year + '-' + month.number][0])"
                color="primary"
                icon
                flat
              >
                <v-icon>mdi-file-document-outline</v-icon>
              </v-btn>
              <v-btn
                v-if="documents[worker.value][year + '-' + month.number].length > 1"
                @click="multiDownload(documents[worker.value][year + '-' + month.number])"
                color="primary"
                icon
                flat
              >
                <v-icon>mdi-package-variant-closed</v-icon>
              </v-btn>
            </template>
          </td>
        </tr>
      </og-table-body>

      <template v-else>
        <tr>
          <td colspan="13">
            <div class="py-5 text-xs-center big-loading-table">
              <v-progress-circular size="100" color="primary" indeterminate></v-progress-circular>
            </div>
          </td>
        </tr>
      </template>
    </og-table>
  </v-container>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import OgTable from '@/components/commons/OgTable.vue';
import OgTableBody from '@/components/commons/OgTableBody.vue';
import OgTableHead from '@/components/commons/OgTableHead.vue';
export default {
  components: {
    OgTable,
    OgTableBody,
    OgTableHead,
  },
  props: {
    year: {
      type: [String, Number],
    },
  },
  data() {
    return {
      documentWorkers: [],
      documentsReady: false,
      documents: {},
      retencionesDocumentTypes: [],
      retencionesDocumentsReady: false,
      retencionesDocuments: {},
      tcDocumentTypes: [],
      tcDocumentTypeLabels: {
        TC1: 'RLC - Recibo de Liquidación de Cotizaciones (antiguo TC1)',
        TC2: 'RNT - Relación Nominal de Trabajadores (antiguo TC2)',
      },
      tcDocumentsReady: false,
      tcDocuments: {},
      currentMonth: 'OCT',
      months: [
        {
          number: '01',
          label: 'ENE',
        },
        {
          number: '02',
          label: 'FEB',
        },
        {
          number: '03',
          label: 'MAR',
        },
        {
          number: '04',
          label: 'ABR',
        },
        {
          number: '05',
          label: 'MAY',
        },
        {
          number: '06',
          label: 'JUN',
        },
        {
          number: '07',
          label: 'JUL',
        },
        {
          number: '08',
          label: 'AGO',
        },
        {
          number: '09',
          label: 'SEP',
        },
        {
          number: '10',
          label: 'OCT',
        },
        {
          number: '11',
          label: 'NOV',
        },
        {
          number: '12',
          label: 'DIC',
        },
      ],
    };
  },

  computed: {
    clavedat() {
      return this.$store.state.clavedat;
    },
  },
  mounted() {
    this.getTCDocuments();
    this.getNominaDocuments();
    this.getRetencionesDocuments();
  },
  watch: {
    year: function(val, oldVal) {
      this.getUserObligations(this.clavedat, val);

      // console.log('new: %s, old: %s', val, oldVal)
    },
  },
  methods: {
    getTCDocuments() {
      this.tcDocumentsReady = false;
      const config = {
        params: {
          constraint: {
            'categories.name': 'Laboral',
            month: this.year + '-:like',
            type: 'TC:like',
          },
        },
      };

      apiCtrl
        .get('/consultant-document/clavedat/' + this.clavedat, config)
        .then(res => {
          let types = {};
          this.tcDocumentTypes = [];
          res.data.data.forEach(doc => {
            if (!types.hasOwnProperty(doc.type)) {
              types[doc.type] = {
                label: this.tcDocumentTypeLabels[doc.type],
                value: doc.type,
              };
              this.tcDocumentTypes.push({
                label: this.tcDocumentTypeLabels[doc.type],
                value: doc.type,
              });
            }
          });

          this.tcDocumentTypes.forEach(docType => {
            res.data.data.forEach(doc => {
              if (!this.tcDocuments.hasOwnProperty(docType.value)) {
                this.tcDocuments[docType.value] = {};
              }

              if (doc.type === docType.value) {
                if (!this.tcDocuments[docType.value].hasOwnProperty(doc.month)) {
                  this.tcDocuments[docType.value][doc.month] = [];
                }
                this.tcDocuments[doc.type][doc.month].push(doc);
              }
            });
          });

          console.log(this.tcDocuments);
          this.tcDocumentsReady = true;
        })
        .catch(err => {
          this.documentsReady = true;
        });
    },
    getNominaDocuments() {
      this.documentsReady = false;
      const config = {
        params: {
          constraint: {
            'categories.name': 'laboral',
            month: this.year + '-:like',
            type: 'Nomina:like',
          },
        },
      };

      apiCtrl
        .get('/consultant-document/clavedat/' + this.clavedat, config)
        .then(res => {
          let workers = {};
          this.documentWorkers = [];
          res.data.data.forEach(doc => {
            if (!workers.hasOwnProperty(doc.worker)) {
              workers[doc.worker] = {
                label: doc.worker,
                value: doc.worker,
              };
              this.documentWorkers.push({
                label: doc.worker,
                value: doc.worker,
              });
            }
          });

          this.documentWorkers.forEach(docWorker => {
            res.data.data.forEach(doc => {
              if (!this.documents.hasOwnProperty(docWorker.value)) {
                this.documents[docWorker.value] = {};
              }

              if (doc.worker === docWorker.value) {
                if (!this.documents[docWorker.value].hasOwnProperty(doc.month)) {
                  this.documents[docWorker.value][doc.month] = [];
                }
                this.documents[doc.worker][doc.month].push(doc);
              }
            });
          });

          console.log(this.documents);
          this.documentsReady = true;
        })
        .catch(err => {
          this.documentsReady = true;
        });
    },
    getRetencionesDocuments() {
      this.retencionesDocumentsReady = false;
      const config = {
        params: {
          constraint: {
            'categories.name': 'laboral',
            month: this.year + '-:like',
            type: 'Retenciones:like',
          },
        },
      };

      apiCtrl
        .get('/consultant-document/clavedat/' + this.clavedat, config)
        .then(res => {
          let types = {};
          this.retencionesDocumentTypes = [];
          res.data.data.forEach(doc => {
            if (!types.hasOwnProperty(doc.type)) {
              const label = `Certificado de retenciones de IRPF ${doc.month.slice(0, -3)}`;

              types[doc.type] = {
                label: label,
                value: doc.type,
              };
              this.retencionesDocumentTypes.push({
                label: label,
                value: doc.type,
              });
            }
          });

          this.retencionesDocumentTypes.forEach(document => {
            res.data.data.forEach(doc => {
              if (!this.retencionesDocuments.hasOwnProperty(document.value)) {
                this.retencionesDocuments[document.value] = {};
              }

              if (doc.type === document.value) {
                if (!this.retencionesDocuments[document.value].hasOwnProperty(doc.month)) {
                  this.retencionesDocuments[document.value][doc.month] = [];
                }
                this.retencionesDocuments[doc.type][doc.month].push(doc);
              }
            });
          });

          console.log(this.retencionesDocuments);
          this.retencionesDocumentsReady = true;
        })
        .catch(err => {
          this.documentsReady = true;
        });
    },
    downloadEntity(entity) {
      console.log(entity);
      if (entity.hasOwnProperty('media') && entity.media.length > 0) {
        apiCtrl
          .get('/document/download/' + entity.media[0].id)
          .then(res => {
            apiCtrl.downloadFile(res.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    multiDownload(documents) {
      let ids = [];
      let name = '';
      documents.forEach(entity => {
        if (!name) {
          name = entity.type + '-' + entity.month;
        }
        if (entity.hasOwnProperty('media') && entity.media.length > 0) {
          entity.media.forEach(media => {
            ids.push(media.id);
          });
        }
      });

      return apiCtrl.downloadBlob('/document/multi-download', {
        params: {
          name: name,
          ids: ids,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.worker-name-cell {
  min-width: 250px;
}

.big-loading-table {
  min-height: 100px;
}
</style>
